import { render, staticRenderFns } from "./WorldMap.vue?vue&type=template&id=555e44b8&"
import script from "./WorldMap.vue?vue&type=script&lang=js&"
export * from "./WorldMap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\soiko\\Documents\\Projects\\game\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('555e44b8')) {
      api.createRecord('555e44b8', component.options)
    } else {
      api.reload('555e44b8', component.options)
    }
    module.hot.accept("./WorldMap.vue?vue&type=template&id=555e44b8&", function () {
      api.rerender('555e44b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/WorldMap.vue"
export default component.exports